/* Ready-made bracelets: the 功效 filter on the menu page, and the phone sticky
   buy bar on the product page. */
(function () {
  'use strict';

  /* ---- menu filter ---- */
  function setupMenu(menu) {
    if (menu._jsrBound) return;
    menu._jsrBound = true;
    var grid = menu.querySelector('[data-jsr-grid]');
    var count = menu.querySelector('[data-jsr-count]');
    if (!grid) return;
    var cards = function () { return Array.prototype.slice.call(grid.querySelectorAll('[data-jsr-card]')); };
    var tab = 'main', effect = '';
    /* The grid holds both tabs' cards; a card shows when it belongs to the open
       tab and (on the bracelet tab) matches the chosen 功效. */
    function apply() {
      var shown = 0;
      cards().forEach(function (c) {
        var inTab = (c.getAttribute('data-group') || 'main') === tab;
        var list = (c.getAttribute('data-effects') || '').split(',');
        var on = inTab && (tab !== 'main' || !effect || list.indexOf(effect) > -1);
        c.hidden = !on;
        c.classList.toggle('is-filtered', !on);
        if (on) shown++;
      });
      grid.classList.toggle('is-empty', shown === 0);
      if (count) count.textContent = shown + ' 款';
      menu.querySelectorAll('[data-jsr-filter]').forEach(function (b) {
        b.classList.toggle('is-on', (b.getAttribute('data-jsr-filter') || '') === effect);
      });
      menu.querySelectorAll('[data-jsr-tab]').forEach(function (b) {
        var on = b.getAttribute('data-jsr-tab') === tab;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      /* filters, glossary and the customizer nudge belong to the bracelet tab only */
      menu.querySelectorAll('[data-jsr-only]').forEach(function (el) {
        el.hidden = el.getAttribute('data-jsr-only') !== tab;
      });
      /* remember the choice in the URL so a shared link opens on the same tab */
      try {
        var u = new URL(window.location.href);
        if (effect) u.searchParams.set('fx', effect); else u.searchParams.delete('fx');
        if (tab !== 'main') u.searchParams.set('tab', tab); else u.searchParams.delete('tab');
        history.replaceState(null, '', u.toString());
      } catch (err) { /* ignore */ }
    }
    menu.addEventListener('click', function (e) {
      var t = e.target.closest('[data-jsr-tab]');
      if (t) { tab = t.getAttribute('data-jsr-tab') || 'main'; effect = ''; apply(); return; }
      var b = e.target.closest('[data-jsr-filter]');
      if (!b) return;
      effect = b.getAttribute('data-jsr-filter') || '';
      apply();
    });
    try {
      var u0 = new URL(window.location.href);
      var fx = u0.searchParams.get('fx'), tb = u0.searchParams.get('tab');
      if (tb && menu.querySelector('[data-jsr-tab="' + tb + '"]')) tab = tb;
      if (fx && menu.querySelector('[data-jsr-filter="' + fx + '"]')) effect = fx;
    } catch (err) { /* ignore */ }
    apply();
  }

  /* ---- sticky buy bar (phones) ---- */
  function setupSticky(bar) {
    if (bar._jsrBound) return;
    bar._jsrBound = true;
    var real = function () {
      return document.querySelector('.product-form__buy-buttons button[type="submit"], .product-form__cart-submit, button[name="add"]');
    };
    var btn = bar.querySelector('[data-jsr-sticky-btn]');
    if (btn) btn.addEventListener('click', function () {
      var r = real();
      if (!r) return;
      r.click();
      /* the real button is off screen; show the buyer where the feedback is */
      if (r.disabled) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var sync = function () {
      var r = real();
      if (!r || window.matchMedia('(min-width: 901px)').matches) { bar.classList.remove('is-on'); document.body.classList.remove('jsr-has-sticky'); return; }
      var rect = r.getBoundingClientRect();
      var visible = rect.bottom > 0 && rect.top < window.innerHeight - 10;
      /* hide while the real button is on screen, and before the buyer has scrolled past the gallery */
      var on = !visible && rect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('jsr-has-sticky', on);
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
  }

  /* ---- banner slider ---- */
  function setupSlider(el) {
    if (el._jsrBound) return;
    el._jsrBound = true;
    var track = el.querySelector('[data-jsr-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-jsr-dot]'));
    if (!track || slides.length < 2) return;
    var i = 0, timer = null, interval = parseInt(el.getAttribute('data-interval'), 10) || 4000;
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    };
    var paint = function () {
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };
    /* a finger swipe moves the track without us: read the position back */
    var onScroll = function () {
      var w = track.clientWidth || 1;
      var k = Math.round(track.scrollLeft / w);
      if (k !== i) { i = Math.max(0, Math.min(slides.length - 1, k)); paint(); }
    };
    var start = function () { stop(); timer = setInterval(function () { go(i + 1); paint(); }, interval); };
    var stop = function () { if (timer) clearInterval(timer); timer = null; };
    track.addEventListener('scroll', onScroll, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-jsr-dot'), 10) || 0); paint(); start(); }); });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', start, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
    paint();
  }

  function boot() {
    document.querySelectorAll('[data-jsr-slider]').forEach(setupSlider);
    document.querySelectorAll('[data-jsr-menu]').forEach(setupMenu);
    document.querySelectorAll('[data-jsr-sticky]').forEach(setupSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('jstudios:grid:swapped', boot);
})();
